import {
  InputTypeEnum,
  IWorkContentDocumentsItem,
  IWorkContentFull,
  IWorkContentTextItem,
  WorkContentType,
} from '../../../../shared/types/workContent.types';

export interface ISelectedDocToReplace {
  oldSrc: string;
  newSrc: string | null;
  docId: string;
}

export const getModelNamePrefix = (inputType?: InputTypeEnum) => {
  switch (inputType) {
    case InputTypeEnum.IMAGE:
      return InputTypeEnum.IMAGE.toLowerCase();
    case InputTypeEnum.VIDEO:
      return InputTypeEnum.VIDEO.toLowerCase();
    case InputTypeEnum.FILE_PICKER:
      return InputTypeEnum.FILE_PICKER.toLowerCase();
    case InputTypeEnum.AUDIO:
      return InputTypeEnum.AUDIO.toLowerCase();
    case InputTypeEnum.MULTIPLE:
      return InputTypeEnum.MULTIPLE.toLowerCase();
  }

  return '';
};

export const isInputTypeKnown = (inputType: InputTypeEnum) => Object.values(InputTypeEnum).includes(inputType);

export const getDefaultValuesWorkData = (workContents: IWorkContentFull[][]) => {
  return Object.fromEntries(
    workContents
      .filter((i) => i[0].type !== 'SOURCE_CONTENT')
      .flat()
      .map((i) => {
        const prefix = getModelNamePrefix(i.inputType);
        const key = i.type === WorkContentType.DOCUMENTS ? `${prefix}${i.id}` : i.modelName;

        return i.type === WorkContentType.DOCUMENTS
          ? [
              key,
              {
                id: i.id,
                type: WorkContentType.DOCUMENTS,
                value:
                  (i.item as IWorkContentDocumentsItem)?.documents?.reduce((acc, curr) => acc + '_' + curr.id, '') ||
                  '',
                mandatory: !!i.mandatory,
                inputType: i.inputType,
              },
            ]
          : [
              key,
              {
                id: i.id,
                type: i.inputType === 'DATE' ? 'DATE' : 'STRING', // TODO: Рефакторинг
                value: (i.item as IWorkContentTextItem)?.text || i?.defaultValue || '',
                mandatory: !!i.mandatory,
                inputType: i.inputType,
              },
            ];
      }),
  );
};

export const populateBaseForm = (
  form: Record<string, string>,
  baseForm: Record<
    string,
    {id: number; value: string | File[]; type: string; mandatory: boolean; inputType?: InputTypeEnum}
  >,
) => {
  const baseFormObj: Record<
    string,
    {id: number; value: string | File[]; type: string; mandatory: boolean; inputType?: InputTypeEnum}
  > = JSON.parse(JSON.stringify(baseForm));

  for (const key in form) {
    baseFormObj[key].value = form[key];
  }

  return baseFormObj;
};

// todo:
// maxFiles
// эндпоинты на точечное обновление
// пресейв
